import "./SinglePostTemplate.module.css"
import MainNavigation from "@/reusable_sections/Header"
import SinglePostTemplateSection from "./sections/SinglePostTemplateSection"
import SariHutFooter from "@/reusable_sections/Footer"

export default function SinglePostTemplatePage() {

  return (
    <div>
      <MainNavigation />
      <SinglePostTemplateSection />
      <SariHutFooter />
    </div>
  )
}
